<template>
  <v-dialog v-model="fullImageDialog" fullscreen>
    <v-card>
      <!-- <pre>{{item.Media}}</pre> -->
      <div v-for="image in item.Media" :key="image.id">
        <v-img :src="`${image.s3url}-web.jpg`" width="100%" height="100%" contain @click="closeDialog"></v-img>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data(){
    return{
      item: {},
      fullImageDialog: false,
    }
  },
  methods: {
    openDialog(articledata) {
      this.item = articledata;
      this.fullImageDialog = true;
    },
    closeDialog(){
      this.fullImageDialog = false;
    }
  }
}
</script>